import { get } from "@u/request";
const user = {
    state: {
        user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {},
        visibleLogin: false,
        menuId: sessionStorage.getItem('menuId') || 0,
        includeArr: [],
        pNumber: 0
    },
    mutations: {
        SET_USER: (state, user) => {
            state.user = user;
            sessionStorage.setItem('user', JSON.stringify(user))
        },
        SET_VISIBLE_LOGIN: (state, visible) => {
            state.visibleLogin = visible
        },
        SET_MENUID: (state, menuId) => {
            state.menuId = menuId;
            sessionStorage.setItem('menuId', menuId)
        },
        // 缓存页面
        SET_INCLUDEARR: (state, name = []) => {
            state.includeArr = name;

        },
        SET_P_NUMBER: (state, pNumber) => {
            state.pNumber = pNumber
        }
    },
    actions: {
        getCheck ({ commit }) {
            return new Promise((resolve, reject) => {
                get("lib/consult/check").then(({ data }) => {
                    commit('SET_P_NUMBER', data)
                    resolve(data)
                }).catch(error => {
                    reject(error)
                });
            })
        }
    }
}

export default user